var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navbar-demo"}},[_c('navbar-default'),_c('navbar-input'),_c('navbar-type'),_c('navbar-color'),_c('navbar-collapse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }